import {
  HOME_LOAN_PURCHASE,
  HOME_LOAN_REFINANCE,
  HOME_LOAN_MONTHLY_PAYMENT_CALCULATOR,
  HOME_LOAN_ABOUT_REFINANCE,
  HOME_LOAN_ABOUT_MORTAGE,
  HOME_LOAN_EQUITY,
} from 'types/mrph.pageName.constants';
import { MORTGAGE_VERTICAL } from 'types/mrph.vertical.constants';

const basePath = '/offers?vertical=HOME_LOAN&tab=';

export const HOME_LOANS_TABS = [
  'newHome',
  'homeRefinance',
  'aboutMortgage',
  'aboutRefinance',
  'monthlyPaymentCalculator',
  'homeEquity',
];

export const TABS_TYPE = {
  newHome: {
    clickType: HOME_LOAN_PURCHASE,
    path: `${basePath}new`,
    Vertical: MORTGAGE_VERTICAL,
  },
  homeRefinance: {
    clickType: HOME_LOAN_REFINANCE,
    path: `${basePath}infoAndTools`,
    Vertical: MORTGAGE_VERTICAL,
  },
  monthlyPaymentCalculator: {
    clickType: HOME_LOAN_MONTHLY_PAYMENT_CALCULATOR,
    path: `${basePath}calculator`,
    Vertical: MORTGAGE_VERTICAL,
  },
  aboutRefinance: {
    clickType: HOME_LOAN_ABOUT_REFINANCE,
    path: `${basePath}aboutRefinance`,
    Vertical: MORTGAGE_VERTICAL,
  },
  aboutMortgage: {
    clickType: HOME_LOAN_ABOUT_MORTAGE,
    path: `${basePath}aboutMortgage`,
    Vertical: MORTGAGE_VERTICAL,
  },
  homeEquity: {
    clickType: HOME_LOAN_EQUITY,
    path: `${basePath}homeEquity`,
    Vertical: MORTGAGE_VERTICAL,
  },
};

export const TABS_ROUTE = {
  [`${basePath}infoAndTools`]: 'homeRefinance',
  [`${basePath}calculator`]: 'monthlyPaymentCalculator',
  [`${basePath}new`]: 'newHome',
  [`${basePath}aboutMortgage`]: 'aboutMortgage',
  [`${basePath}aboutRefinance`]: 'aboutRefinance',
  [`${basePath}homeEquity`]: 'homeEquity',
};

export const getLoanTermInMonths = name => {
  if (!name) return null;
  const years = parseInt(name.match(/\d+/)?.[0] || '0', 10);
  return years > 0 ? years * 12 : null;
};
